import Title from 'antd/es/typography/Title';

export default function CityHasNoModule() {
    return (
        <Title>Município não tem acesso ao módulo.</Title>
    )
}
